import { getData, postData, deleteData } from "./UtilityFunctions";

const PATCH_ENDPOINT = "/patches";

export async function getAllPatchNotes() {
  var response = await getData(PATCH_ENDPOINT, { client: "web" });
  return response?.data || [];
}

export async function getActivePatchNote() {
  var patches = await getAllPatchNotes();
  return patches.find((patch) => patch.active === true) || null;
}

export async function getActivePatchNotes() {
  var patches = await getAllPatchNotes();
  return patches.filter((patch) => patch.active === true);
}

export async function getPatchNoteById(id) {
  var patches = await getAllPatchNotes();
  return patches.find((patch) => patch.id === id);
}

export async function createPatchNote(title, content, authorId) {
  var response = await postData(PATCH_ENDPOINT, {
    body: {
      authorId,
      title,
      content,
      clients: ["web"],
      active: true
    }
  });
  return response;
}

export async function updatePatchNote(id, updates, authorId, patchData) {
  var body = {
    set: {
      authorId,
      title: updates.title,
      content: updates.content,
      clients: ["web"],
      active: patchData.active || false
    }
  };
  var response = await postData(`${PATCH_ENDPOINT}/${id}`, { body });
  return response;
}

export async function deletePatchNote(id) {
  var response = await deleteData(`${PATCH_ENDPOINT}/${id}`);
  return response;
}

export async function setActivePatchNote(id, active) {
  var body = {
    set: {
      active
    }
  };
  var response = await postData(`${PATCH_ENDPOINT}/${id}`, { body });
  return response;
}

// TO DO : When ready, we can add active patch notes etc which will show on page load.
// For now we just want to createe & display patch notes in separate page.

// export function getViewedPatchIds() {
//   try {
//     const data = localStorage.getItem(VIEWED_PATCHES_KEY);
//     return data ? JSON.parse(data) : [];
//   } catch (err) {
//     console.error("Error retrieving viewed patches:", err);
//     return [];
//   }
// }

// export function markPatchAsViewed(patchId) {
//   const viewed = getViewedPatchIds();
//   if (!viewed.includes(patchId)) {
//     viewed.push(patchId);
//     localStorage.setItem(VIEWED_PATCHES_KEY, JSON.stringify(viewed));
//   }
// }

// export function hasViewedPatch(patchId) {
//   return getViewedPatchIds().includes(patchId);
// }

// export async function getUnviewedPatchNote() {
//   try {
//     const activePatch = await getActivePatchNote();
//     if (!activePatch) return null;

//     if (!hasViewedPatch(activePatch.id)) {
//       return activePatch;
//     }
//     return null;
//   } catch (err) {
//     console.error("Error getting unviewed patch note:", err);
//     return null;
//   }
// }
